/* eslint-disable @typescript-eslint/no-unsafe-return */
import { joinPath } from "../../utils/string";
import { SoapService, BaseEaiwsService } from "../SoapService";
import { CatalogItem, TopCatalogItems, PackageInfo } from "./CatalogTypes";
export class CatalogService extends BaseEaiwsService {
    constructor(pOwner, pBaseUrl, pSessionId) {
        super(pOwner, joinPath(pBaseUrl, "EAI/Catalog"), "http://catalog.ws.eai.egr/", pSessionId);
    }
    getCatalogItem(pPath, pOptions) {
        const tPromise = this.soapAjax("getCatalogItem", {
            sessionId: this.mSessionId,
            path: pPath,
            options: pOptions
        }).then((pResponse) => {
            return (CatalogItem.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    getCatalogPath(pCatalogId, pCatNodeKey) {
        const tPromise = this.soapAjax("getCatalogPath", {
            sessionId: this.mSessionId,
            catalogId: pCatalogId,
            catNodeKey: pCatNodeKey
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    /**
     * Note: The server response will be cached to speed up further calls.
     */
    getLanguages() {
        if (this.mLanguages != null)
            return (Promise.resolve(this.mLanguages));
        const tPromise = this.soapAjax("getLanguages", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            this.mLanguages = SoapService.SoapDataToArrayNU(pResponse);
            return (this.mLanguages);
        });
        return (tPromise);
    }
    getPackageInfo(pManuIds, pPackageIds, pOptions) {
        const tPromise = this.soapAjax("getPackageInfo", {
            sessionId: this.mSessionId,
            manuIds: pManuIds,
            packageIds: pPackageIds,
            options: pOptions
        }).then((pResponse) => {
            return (PackageInfo.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    listCatalogItems(pPath, pOptions) {
        const tPromise = this.soapAjax("listCatalogItems", {
            sessionId: this.mSessionId,
            path: pPath,
            options: pOptions
        }).then((pResponse) => {
            return (CatalogItem.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    searchArticle(pSearch, pOptions) {
        const tPromise = this.soapAjax("searchArticle", {
            sessionId: this.mSessionId,
            search: pSearch,
            options: pOptions
        }).then((pResponse) => {
            return (TopCatalogItems.FromSoap(pResponse));
        });
        return (tPromise);
    }
    searchCatalogItems(pSearch, pOptions) {
        const tPromise = this.soapAjax("searchCatalogItems", {
            sessionId: this.mSessionId,
            search: pSearch,
            options: pOptions
        }).then((pResponse) => {
            return (TopCatalogItems.FromSoap(pResponse));
        });
        return (tPromise);
    }
    searchResource(pSearch, pOptions) {
        const tPromise = this.soapAjax("searchResource", {
            sessionId: this.mSessionId,
            search: pSearch,
            options: pOptions
        }).then((pResponse) => {
            return (TopCatalogItems.FromSoap(pResponse));
        });
        return (tPromise);
    }
    setLanguages(pLanguages) {
        const tPromise = this.soapAjax("setLanguages", {
            sessionId: this.mSessionId,
            languages: pLanguages
        }).then(() => {
            this.mLanguages = undefined;
            this.mOwner.eventCatalogLanguagesChanged.trigger();
        });
        return (tPromise);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _clearCache() {
        this.mLanguages = undefined;
    }
}
